namespace SPA {
	export namespace Realtor {

		export class ExposeBuilder
			extends ObjectDataBuilder<RealtorObjectModel> {

			private m_Parent: JQuery | ui.base.BaseHTMLElement | null;
			private DocumentManager: DocumentManager;

			private readonly MainImageID: number = 28;
			private readonly CertificateID: number = 37;
			private readonly MapMikrolageID: number = 29;
			private readonly MapMakrolageID: number = 11;
			private readonly DescriptionImageID: number = 30;
			private readonly EquipmentImageID: number = 31;
			private readonly LayoutOneID: number = 32;
			private readonly LayoutTwoID: number = 33;
			private readonly LayoutThreeID: number = 34;
			private readonly LayoutFourID: number = 35;
			private readonly LayoutOtherID: number = 36;
			private readonly CompanyLogoID: number = 39;
			private readonly EmployeeImageID: number = 38;

			private employee_address: string = "";
			private mainImageFilename:string;

			public constructor(data: RealtorObjectModel, docManager: DocumentManager) {
				super(data);

				// Setup Main Image
				this.mainImageFilename = 'assets/images/placeholder-image.png';
				if (data.MainImage)
				{
					this.mainImageFilename = data.MainImage;
					if (this.mainImageFilename.indexOf('http') !== 0) {
						this.mainImageFilename = app.getRemotePath() + this.mainImageFilename;
					}
				}



				this.m_Parent = null;
				this.DocumentManager = docManager; // Data from Page.ts
			}

			public rebuild(root: ui.base.BaseHTMLElement | JQuery, navigation?: Navigation): ExposeBuilder {
				this.m_Parent = root;
				this.m_Parent.empty();
				const basicBox = new ui.Box.Box();

				basicBox.clearTitle();
				// basicBox.addTitle('Exposé erstellen');
				// basicBox.rebuild(root.empty());
				basicBox.rebuild(root);
				basicBox.append(ui.$$.h(2, [$('<span>Exposé erstellen</span>')]).addClass('segment'));
				// Iterate over all images and fetch the neccessary ones

				// Replaced by RealtorObject Main Image
				//const MainImage = this.getImage(this.MainImageID);

				const CertificateImage = this.getImage(this.CertificateID);
				const CompanyLogo = this.getImage(this.CompanyLogoID);
				const EmployeeImage = this.getImage(this.EmployeeImageID);
				const imageMikroLage = this.getImage(this.MapMikrolageID);
				const imageMakroLage = this.getImage(this.MapMakrolageID);
				const imageDesc = this.getImage(this.DescriptionImageID);
				const imageAusstattung = this.getImage(this.EquipmentImageID);
				const imageOther = this.getImage(this.LayoutOtherID);
				const layoutOne = this.getImage(this.LayoutOneID);
				const layoutTwo = this.getImage(this.LayoutTwoID);
				const layoutThree = this.getImage(this.LayoutThreeID);
				const layoutFour = this.getImage(this.LayoutFourID);

				// Set Address Fields for Hidden Fills
				const employee = app.getAuthenticationManager().getEmployee();
				if (employee) {
					const address = _.find(employee.Address, (a) => a.AddressType === 'PostalAddress');
					if( address) {
						const addressTyped: Wollmilch.PostalAddressObject = address as Wollmilch.PostalAddressObject;
						this.employee_address += addressTyped.Street + " " + addressTyped.HouseNumber + "\n";
						this.employee_address += addressTyped.PostalCode + " " + addressTyped.City + "\n";
					}

					const email = _.find(employee.Address, (a) => a.AddressType === 'Email');
					if (email && email.display != "") {
						this.employee_address += "\n" + "E-Mail: \t" + email.display;
					}

					const cell = _.find(employee.Address, (a) => a.AddressType === 'Phone' && a.KindOf === 'cell');
					if (cell && cell.display != ""){
						this.employee_address += "\n" + "Telefon: \t";
					}

					const mobile = _.find(employee.Address, (a) => a.AddressType === 'Phone' && a.KindOf === 'mobile');
					if (mobile && mobile.display != ""){
						this.employee_address += "\n" + "Mobil: \t" + mobile.display;
					}
				}

				let htmlImp = '';
				let idx = 0;

				const exposeImg = [];
				const objectImg = [];

				for (const image of this.DocumentManager.getFiles()) {
					if (image.group_id === 4 && image.default_id >= 32 && image.default_id <= 35) {
						exposeImg.push(image);
					}
					if (image.group_id !== 5 || image.id === 0) {
						continue;
					}

					let filename = image.filename;
					if (filename.indexOf('http') !== 0) {
						filename = app.getRemotePath() + filename;
					}

					htmlImp +=
						'<div class="form-group col-sm-3">' +
						'<div class="image-text img-txt-edit">' +
						'<div class="input-group">' +
						'<label class="input-group-addon">Bildtext</label>' +
						'<input type="text" class="form-control" name="expose.impression[' + idx + '][text]" value="' + image.title + '" placeholder="Text zum Bild">' +
						// '<input type="text" class="form-control" name="expose.impression[' + idx + '][text]" value="" placeholder="Text zum Bild">' +
						'</div>' +
						'<input type="hidden" name="expose.impression[' + idx + '][image]" value="' + filename + '" />' +
						'<img alt="Bildvorschau" src="' + filename + '"/>' +
						'</div>' +
						'</div>';

					idx++;
					if ((idx) % 3 === 0) {
						htmlImp += '<div class="clearfix"></div>';
					}
				}

				const askingPrince = this.m_Data.AdvData && this.m_Data.AdvData.price
					? accounting.formatMoney(this.m_Data.AdvData.price) + ' €'
					: this.m_Data.Data.general && this.m_Data.Data.general.price.value
						? accounting.formatMoney(this.m_Data.Data.general.price.value) + ' €'
						: '(ohne Preis)';

				const constructionYear = this.m_Data.AdvData && this.m_Data.AdvData.construction_year
					? this.m_Data.AdvData.construction_year
					: this.m_Data.Data.details && this.m_Data.Data.details.object.construction_year
					? this.m_Data.Data.details.object.construction_year
					: '';

				// const conditionInput = new ui.Form.TextInput(
				// 	SPA.types.Object.Condition[this.m_Data.Data.details ? this.m_Data.Data.details.object.usability : ''], {
				// 		control: true,
				// 		name: 'expose.status',
				// });
				// conditionInput.Initialize();

				let exposeHtml = '';
				let index = 0;
				let filename: string = "assets/images/placeholder-image.png";
				for (const expose of exposeImg) {
					if(filename !== expose.filename){
						exposeHtml += `<div class="form-group col-sm-3">
										<div class="image-text img-txt-edit">
											<div class="input-group">
												<label class="input-group-addon">Bildtext</label>
												<input type="text" class="form-control" name="expose.layout[${index}][text]" value="${expose.title || expose.default_title}" placeholder="individueller Text">
											</div>
											<input type="hidden" name="expose.layout[${index}][image]" value="${expose.filename}" />
											<img alt="Bildvorschau" src="${expose.filename}">
										</div>
									</div>`;

					}
					index++;
				}

				const objectHtml = '';
				index = 0;
				for (const img of objectImg) {
					exposeHtml += `<div class="form-group col-sm-3">
									<div class="image-text img-txt-edit">
										<div class="input-group">
											<label class="input-group-addon">Bildtext</label>
											<input type="text" class="form-control" name="expose.layout[${index}][text]" value="${img.title || img.default_title}" placeholder="individueller Text">
										</div>
										<input type="hidden" name="expose.layout[${index}][image]" value="${img.filename}" />
										<img alt="Bildvorschau" src="${img.filename}">
									</div>
								</div>`;
					index++;
				}
				const ecInput = new ui.Form.TextInput(SPA.types.Object.EnergieCertificate[this.m_Data.AdvData.energy_certificate], {
					control: true,
					name: 'expose.energy_cert',
				});
				ecInput.Initialize();
				const html = $('<form class="c2 object-expose" action="create_expose.php">')
					.append(`
					<fieldset class="form-horizontal">
						<legend>Deckblatt</legend>
					    <div class="col-sm-8">
							<div class="form-group">
								<label class="control-label col-sm-3">Slogan</label>
								<div class="col-sm-9">
									<input class="form-control" type="text" name="expose.slogan" value="${this.m_Data.Data.general ? this.m_Data.Data.general.title : ''}" />
								</div>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3">Adresse</label>
								<div class="col-sm-9">
									<input class="form-control" type="text" name="expose.address" value="${this.m_Data.Address.display}" />
								</div>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3">Objektnummer</label>
								<div class="col-sm-9">
									<input class="form-control" type="text" name="expose.oid" value="${this.m_Data.ObjectNumber}" />
								</div>
							</div>
						</div>
						<div class="col-sm-4">
							<p>Hauptbild</p>
							<input type="hidden" name="expose.image[main]" value="${this.mainImageFilename}" />
							<img class="thumb" src="${this.mainImageFilename}" />
						</div>
					</fieldset>`)
					.append(`
						<fieldset class="col-sm-5 form-horizontal">
						  <legend>Eckdaten</legend>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Objektart</label>
						    <div class="col-sm-9">
						       Haus
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Objekttyp</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.housetype" value="${this.m_Data.Data.common ? SPA.types.Object.Type[this.m_Data.Data.common.type.type] : ''}" />
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Nutzungsart</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.usage" value="Wohnen" />
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Vermarktungsart</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.marketing" value="Verkauf" />
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Kaufpreis</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.price" value="${askingPrince}" />
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Außen-Provision</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.commission" value="${this.m_Data.Data.general && this.m_Data.Data.general.fee.exterior ? this.m_Data.Data.general.fee.exterior.value : ''}" />
						    </div>
						  </div>
						</fieldset>`)
					.append(`
						<fieldset class="col-sm-5 col-sm-offset-1 form-horizontal">
						  <legend>Ausstattung</legend>
						  <div class="form-group">
							 <label class="control-label col-sm-3">Zustand</label>
							 <div class="col-sm-9">
							 	<input class="form-control" type="text" name="expose.status" value="${this.m_Data.Data.details ? SPA.types.Object.Condition[this.m_Data.Data.details.object.usability] : ''}" />
							 </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Wohnfläche</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.wf" value="${this.m_Data.Data.details ? this.m_Data.Data.details.living_area.value : ''}" />
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Grundstücksgröße</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.plot_size" value="${this.m_Data.Data.property ? this.m_Data.Data.property.area.building + this.m_Data.Data.property.area.garden : ''}" />
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Anzahl Zimmer</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.rooms" value="${this.m_Data.AdvData.rooms || ''}" />
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Anzahl Badezimmer</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.bath_rooms" value="${this.m_Data.AdvData.bathroom_count || ''}" />
						    </div>
						  </div>
						  <div class="form-group">
						    <label class="control-label col-sm-3">Heizungsart</label>
						    <div class="col-sm-9">
						      <input class="form-control" type="text" name="expose.firing" value="${this.m_Data.AdvData.energy_type ? SPA.types.Object.HeatingType[this.m_Data.AdvData.energy_type] : ''}" />
						    </div>
						  </div>
						</fieldset>
						<div class="clearfix"></div>`)
					.append(
						$('<fieldset class="form-horizontal">')
							.append('<legend>Daten zum Energieausweis</legend>')
							.append(ui.$$.div().addClass('col-sm-8')
								.append($('<div class="form-group">')
									.append('<label class="control-label col-sm-3">Baujahr</label>')
									.append(`<div class="col-sm-9">
						                        <input class="form-control" type="text" name="expose.bj" value="${constructionYear}" />
						                    </div>`)
								)
								.append($('<div class="form-group">')
									.append('<label class="control-label col-sm-3">Energieausweis</label>')
									.append($('<div class="col-sm-9">').append(ecInput.Input()))
								)
								// .append(`<div class="form-group">
								// 		    <label class="control-label col-sm-3">Endenergiebedarf</label>
								// 		    <div class="col-sm-9">
								// 		      <input class="form-control" type="text" name="expose.energy_con" value="" />
								// 		    </div>
								// 		  </div>`)
								.append(`<div class="form-group">
										    <label class="control-label col-sm-3">wesentlicher Energieträger</label>
										    <div class="col-sm-9">
										      <input class="form-control" type="text" name="expose.energy_main" value="${this.m_Data.AdvData.energy_source ? SPA.types.Object.HeatingFeature[this.m_Data.AdvData.energy_source] : ''}" />
										    </div>
										  </div>`)
							)
							.append(ui.$$.div().addClass('col-sm-4')
								.append(`
									<p>Energieausweis</p>
									<input type="hidden" name="expose.image[certificate]" value="${CertificateImage.filename}" />
									<img class="thumb" src="${CertificateImage.filename}" />
								`)
							)
					)
					.append('<div class="clearfix"></div>')
					.append(`
							<fieldset class="expose-freetext">
								<legend>Freitextfelder</legend>
								<div class="row">
									<div class="form-group col-sm-6">
										<label class="control-label col-sm-12">Lage</label>
										<textarea class="form-control test-area" rows="8" name="expose.location">${this.m_Data.AdvData.location || ''}</textarea>
										<p class="counter_msg"></p>
									</div>
									<div class="form-group col-sm-3">
										<p class="control-label col-sm-12">Mikrolage</p>
										<div class="col-sm-12">
											<input type="hidden" name="expose.image[map_mikro]" value="${imageMikroLage.filename}" />
											<img class="thumb" alt="Google | OSM | Mapbox" src="${imageMikroLage.filename}"/>
										</div>
									</div>
									<div class="form-group col-sm-3">
										<p class="control-label col-sm-12">Makrolage</p>
										<div class="col-sm-12">
											<input type="hidden" name="expose.image[map_makro]" value="${imageMakroLage.filename}" />
											<img class="thumb" alt="Google | OSM | Mapbox" src="${imageMakroLage.filename}"/>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group col-sm-6">
										<label class="control-label col-sm-12">Beschreibung</label>
										<textarea class="form-control test-area" rows="8" name="expose.description">${this.m_Data.AdvData.description || ''}</textarea>
										<p class="counter_msg"></p>
									</div>
									<div class="form-group col-sm-6">
										<p class="control-label col-sm-12">Bild zur Beschreibung</p>
										<div class="col-sm-6">
											<input type="hidden" name="expose.image[description]" value="${imageDesc.filename}" />
											<img class="thumb" alt="Bild" src="${imageDesc.filename}"/>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group col-sm-6">
										<label class="control-label col-sm-12">Ausstattung</label>
										<textarea class="form-control test-area" rows="8" name="expose.equipment">${this.m_Data.AdvData.equipment || ''}</textarea>
										<p class="counter_msg"></p>
									</div>
									<div class="form-group col-sm-6">
										<p class="control-label col-sm-12">Bild zur Ausstattung</p>
										<div class="col-sm-6">
											<input type="hidden" name="expose.image[equipment]" value="${imageAusstattung.filename}" />
											<img class="thumb" alt="Bild" src="${imageAusstattung.filename}"/>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="form-group col-sm-6">
										<label class="control-label col-sm-12">Sonstige Angaben</label>
										<textarea class="form-control test-area" rows="8" name="expose.othertext">${this.m_Data.AdvData.others || ''}</textarea>
										<p class="counter_msg"></p>
									</div>
									<div class="form-group col-sm-6">
										<p class="control-label col-sm-12">Bild zu Sonstige Angaben</p>
										<div class="col-sm-6">
											<input type="hidden" name="expose.image[other]" value="${imageOther.filename}" />
											<img class="thumb" alt="Bild" src="${imageOther.filename}"/>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-sm-12">
										<button type="button" class="btn btn-success btn-save-expose-text"><i class="fas fa-save"></i> Freitextfelder speichern</button>
										<input type="hidden" name="expose.logo" value="${CompanyLogo.filename}">
										<input type="hidden" name="expose.employee" value="${EmployeeImage.filename}">
										<input type="hidden" name="expose.employee.name" value="${this.m_Data.Creator.Name} ${this.m_Data.Creator.Surname}">
										<input type="hidden" name="expose.employee.address" value="${this.employee_address}">
									</div>
							</fieldset>`)
					.append(`
							<fieldset>
								<legend>Grundrisse</legend>` + exposeHtml + `
							</fieldset>
					<fieldset>
						<legend>Impressionen</legend>`
						+ htmlImp + '</fieldset>'
					);

				basicBox.append($(html));


				// Set and view the Textarea maximum length to 700
				$('.test-area').on('focus keypress keyup focusout change', function (e) {

					const ml = 700;

					let $this = $(this);
					let msgSpan = $this.parent().find('.counter_msg');
					$this.attr("maxlength", ml);
					let length: number = ($this.val() as string).length;
					let msg = 'Zeichen zur Verfügung: ' + (ml - length).toString() + ' von ' + ml;

					msgSpan.html(msg);
				});


				$('.btn-save-expose-text').on('click', (e) => {
					// Collect expose text
					// Todo generalize this

					const form = $(e.currentTarget).closest('form');
					const textdata = {
						location: form.find("textarea[name='expose.location']").val(),
						description: form.find("textarea[name='expose.description']").val(),
						equipment: form.find("textarea[name='expose.equipment']").val(),
						others: form.find("textarea[name='expose.othertext']").val(),
					};

					app.getObjectManager().saveExposeText(this.m_Data.ObjectNumber, textdata);
				});

				const addbtn = new ui.base.BaseHTMLElement<HTMLButtonElement>('button');
				addbtn.addClass('btn btn-lg btn-success')
					.css({'margin': '0 0 1em 1em'})
					.on(
						{
							click: (e) => this.buildExposePdf(e)
						}
					)
					.append($('<i class="fas fa-plus-circle"></i> <span>Exposé erstellen und anzeigen</span>'));

				basicBox.append(addbtn.Root());
				basicBox.append(ui.$$.div().addClass('expose-download-link'));

				return this;
			}

			private buildUploadForm(ec: Wollmilch.Realtor.EnergyCertificate): void {
				const FileUpload = ui.$$.div();

				// @ts-ignore
				const galleryUploader = new qq.FineUploader(
					{
						element: FileUpload[0],
						template: 'qq-template-gallery',
						multiple: false,
						validation:
							{
								allowedExtensions: ['pdf']
							},
						autoUpload: false,
						emptyError: 'Aux.ERROR.file_empty',
						noFilesError: 'Aux.ERROR.no_files',
						request:
							{
								customHeaders:
									{
										'GSDWollmilch-API-Key': 'API-KEY',
										'GSDWollmilch-API-AuthToken': app.getAuthenticationManager().getAuthToken()
									},
								forceMultipart: true,
								method: 'PUT',
								paramsInBody: true,
								endpoint: (Wollmilch.useHTTPS ? "https" : "http") + "://" + Wollmilch.URL + 'api/v1/artifact/blob/' + ec.Artifact().ID()
							},
						cors:
							{
								// all requests are expected to be cross-domain requests
								expected: true,

								// if you want cookies to be sent along with the request
								sendCredentials: true
							}
					}
				);

				const modal: ui.dialog.Modal = new ui.dialog.Modal(
					{
						size: 'lg',
						head: [ui.$$.h(4, app.getMessage('Aux.BASIC.OBJECT.REALTOR.SHORT.set_energycertificate_file'))],
						body: [FileUpload],
						foot: [
							ui.$$.button().text(app.getMessage('Aux.SAVE_BTN')).addClass('btn btn-success').on(
								'click', () => {
									try {
										galleryUploader.uploadStoredFiles();
									} catch (nofileserror) {
										app.addNotify(
											{
												title: ['FILE_UPLOAD'],
												body: ['ERROR.NO_FILES_SELECTED_TO_UPLOAD'],
												context: 'warning',
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									modal.Hide();

									if (this.m_Parent) {
										this.rebuild(this.m_Parent);
									}
								}
							),
							ui.$$.button().text(app.getMessage('Aux.ABORT_BTN')).addClass('btn btn-danger').on(
								'click', () => modal.Hide()
							)
						]
					}
				);
			}

			private buildExposePdf(e): void
			{
				const button = $(e.currentTarget);

				if (button.is(':disabled'))
				{
					return;
				}

				button.data('text', button.html());
				button.html('<i class="fa fa-spinner fa-spin"></i> Exposé wird erstellt...');
				button.attr('disabled', true);

				$.ajax({
					url: (Wollmilch.useHTTPS ? "https" : "http") + "://" + Wollmilch.URL + AJAXCallbase_e.ROOT + 'expose.php',
					data: button.parent().find('form').serialize(),
					method: 'POST',
					dataType: 'json',
					success: (res) => {
						if (res.file) {

							const downloadName = this.m_Data.Address.Street + ' ' + this.m_Data.Address.HouseNumber
								+ ', ' + this.m_Data.Address.PostalCode + ' ' + this.m_Data.Address.City;
							//
							button.html(button.data('text'));
							button.attr('disabled', false);

							$('.expose-download-link').empty()
								.html(`Falls der Download nicht automatisch startet, <a href="${res.file}" target="_blank" download="Exposé ${downloadName}.pdf">laden Sie Ihr Exposé hier herunter.</a>`);

							// const link = document.createElement("a");
							// link.setAttribute('download', 'Expose.pdf');
							// link.setAttribute('target', '_blank');
							// link.text = "Laden Sie Ihr Exposé jetzt herunten";
							// link.href = res.file;
							// $(link).addClass('btn btn-success').css({marginLeft: '15px'});
							// $(e.currentTarget).replaceWith(link);
						}
					}
				});
			}

			private buildECForm(ec?: Wollmilch.Realtor.EnergyCertificate): void {
				let modal: ui.dialog.Modal;

				const formCallback = ec ?
					(action: string, method: string, params: Wollmilch.Realtor.EnergyCertificateObject) => {
						ec.edit(
							params.Data,
							(response: Wollmilch.ResponseObject, ec: Wollmilch.Realtor.EnergyCertificate) => {
								if (!response.success) {
									app.addNotify(
										{
											title: [ui.$$.h(4, app.getMessage('Aux.BASIC.OBJECT.REALTOR.SHORT.new_additional_energycertificate'))],
											body: ['Energieausweis konnte nicht bearbeitet werden.'],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								if (this.m_Parent) {
									this.rebuild(this.m_Parent);
								}

								modal.Hide();
							}
						);
					} :
					(action: string, method: string, params: Wollmilch.Realtor.EnergyCertificateObject) => {
						Wollmilch.Realtor.EnergyCertificate.create(
							params.ObjectNumber,
							params.KeyDate,
							params.Data,
							(response: Wollmilch.ResponseObject, ec?: Wollmilch.Realtor.EnergyCertificate) => {
								if (!ec) {
									app.addNotify(
										{
											title: [ui.$$.h(4, app.getMessage('Aux.BASIC.OBJECT.REALTOR.SHORT.new_additional_energycertificate'))],
											body: ['Energieausweis konnte nicht erstellt werden.'],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									return;
								}

								if (this.m_Parent) {
									this.rebuild(this.m_Parent);
								}

								modal.Hide();
							}
						);
					};

				const form = new ui.Form.Form(
					// @ts-ignore
					{
						action: '',
						method: 'POST',
						notSwitchable: true,
						static: false,
						// @ts-ignore
						submit: formCallback
					}
				);

				const form_parent = ui.$$.div();

				form.Initialize();

				form.rebuild(form_parent);

				modal = new ui.dialog.Modal(
					{
						size: 'lg',
						head: [ui.$$.h(4, app.getMessage('Aux.BASIC.OBJECT.REALTOR.SHORT.' + (ec ? 'edit_energycertificate' : 'new_additional_energycertificate')))],
						body: [form_parent],
						foot: [
							$(form.Buttons.submit.getElement()).text(app.getMessage(ec ? 'Aux.EDIT_BTN' : 'Aux.SAVE_BTN')),
							$(form.Buttons.cancel.getElement()).on('click', () => modal.Hide()).text(app.getMessage('Aux.ABORT_BTN'))
						]
					}
				);

				const addInput = (input: ui.Form.BasicInputField, baseclass: string[]) => {
					form.Input(input);
					input.Base().addClass(baseclass.join(' '));
				};

				form.append(
					ui.$$.div().addClass('form-group formless').append(
						ui.$$.p().addClass('form-required text-danger small-caps').text(app.getMessage('Aux.REQUIRED_INPUTS'))
					)
				);

				addInput(new ui.Form.HiddenTextInput(this.m_Data.ObjectNumber, 'ObjectNumber'), []);

				const keydate = new ui.Form.DateInput(
					ec ? ec.KeyDate() : new Date(), 'd.m.Y', {
						name: 'KeyDate',
						required: true,
						control: true,
						readonly: ec ? true : false
					}
				).rebuild(
					ui.$$.div().addClass('row').appendTo(form.Root())
						.append(ui.$$.label().addClass('col-xs-12 col-sm-4').text('Stichtag' + '*'))
				);
				if (!ec) {
					addInput(keydate, ['col-xs-12', 'col-sm-8']);
				} else {
					keydate.Base().addClass(['col-xs-12', 'col-sm-8'].join(' '));
				}

				addInput(
					new ui.Form.RadioGroup(
						{
							value: ec ? ec.Type() : null,
							inline: 2,
							required: true,
							name: 'Data.type',
							radioButtons:
								[
									{
										value: 'consumptions',
										title: 'Verbrauchsausweis',
									},
									{
										value: 'needs',
										title: 'Bedarfsausweis'
									}
								]
						}
					).rebuild(
						ui.$$.div().addClass('row').appendTo(form.Root())
							.append(ui.$$.label().addClass('col-xs-12 col-sm-4').text('Art des Ausweis\'' + '*'))
					),
					['col-xs-12', 'col-sm-8']
				);

				addInput(
					new ui.Form.LabelledNumberSlider(
						ec ? ec.OverallEfficiency() || -1 : -1,
						{
							min: 0,
							max: 800,
							step: 1,
							sentinal: 'Keine Angabe',
							name: 'Data.overall-efficiency',
							control: true
						},
						(n: number) => n + ' kWh/(m²*a)'
					).rebuild(
						ui.$$.div().addClass('row').appendTo(form.Root())
							.append(ui.$$.label().addClass('col-xs-12 col-sm-4').text('Endenergiebedarf' + '*'))
					),
					['col-xs-12 col-sm-8']
				);

				addInput(
					new ui.Form.LabelledNumberSlider(
						ec ? ec.PrimaryConsumption() || -1 : -1,
						{
							min: 0,
							max: 800,
							step: 1,
							sentinal: 'Keine Angabe',
							name: 'Data.primary-consumption',
							control: true
						},
						(n: number) => n + ' kWh/(m²*a)'
					).rebuild(
						ui.$$.div().addClass('row').appendTo(form.Root())
							.append(ui.$$.label().addClass('col-xs-12 col-sm-4').text('Primärenergiebedarf' + '*'))
					),
					['col-xs-12 col-sm-8']
				);

				if (ec) {

				}
			}

			private getImage(defaultID: number) {
				const image = this.DocumentManager.getDefaultFile(defaultID);

				if (!image || image.id === 0) {
					image.filename = 'assets/images/placeholder-image.png';
				} else if (image.filename.indexOf('http') !== 0) {
					image.filename = app.getRemotePath() + image.filename;
				}

				return image;
			}

			private downloadFile(data: Wollmilch.ArtifactDownload) {
				const srcStr = 'data:' + data.MimeType + ';' + (data.Base64 ? 'base64,' : '');
				const element = document.createElement('a');
				element.setAttribute('href', srcStr + data.Blob);
				/* TODO sobald in der DB der Dateiname des Artefaktes mitgespeichert wird, diesen verwenden */
				element.setAttribute('download', 'downloadfile.bin' /* TODO data.Filename*/);

				element.style.display = 'none';
				document.body.appendChild(element);
				$(element).on('click', (e) => e.preventDefault());

				element.click();

				document.body.removeChild(element);
			}

			private loadBlob(att: Wollmilch.Realtor.EnergyCertificateObject, onsuccess: (data: Wollmilch.ArtifactDownload) => void) {
				new Wollmilch.AJAX(
					{
						url: 'artifact/download/' + att.Artifact.ID,
						method: 'GET',
						on:
							{
								success: (text: string) => {
									const obj = Wollmilch.jsonize(text);

									if (!obj || obj.success === false) {
										return;
									}

									onsuccess(obj.data);
								}
							}
					}
				).send();
			}

		}

	}
}
